const RETURN_STUB = process.env.REACT_APP_STUBS_ENABLED === "true";

export const OrderStub = {
    create: order => RETURN_STUB && {data: order},
    get: id => RETURN_STUB && {
        data: {
            id,
            customer_account_id: 1
        }
    },
    update: order => RETURN_STUB && {data: order},
    delete: id => RETURN_STUB && {data: {message: "OK"}},
    all: (page=1, pageSize=20) => RETURN_STUB && {
        data: [
            {id: 1, customer_account_id: 1},
            {id: 2, customer_account_id: 1},
            {id: 3, customer_account_id: 1},
            {id: 4, customer_account_id: 1},
            {id: 5, customer_account_id: 1},
        ]
    }
};